import { useMemo, useContext } from 'react';
import { TextureLoader, DoubleSide } from 'three';

import { GameContext, ViewContext } from '@/state/contexts';

// replace with texture of "Buy" in league spartan bold
// shows up in space above what would be next factory
// click to launch same buy factory model

const ButtonSquare3D = ({
	buttonAction,
	type = 'end_turn',
	playerId,
	p = [0, 0, 0],
}) => {
	const scale = 2;
	const buttonHeight = 1 * scale;
	const buttonWidth = buttonHeight;

	const pc: any = useContext(GameContext);

	let pos: [x: number, y: number, z: number] = [
		p[0] || 0,
		p[1] || 0,
		p[2] || 0,
	];

	const { endTurnButtonTexturePath, paymentMode }: any =
		useContext(ViewContext);

	const buttonEndTurnTexture = useMemo(
		() => new TextureLoader().load(endTurnButtonTexturePath),
		[]
	);

	if (!pc) return;

	let buttonTexture = buttonEndTurnTexture;

	// skip if it's not my turn, it's not my playermat, or if I'm in payment mode
	if (
		pc.activePlayerId !== pc.currPlayer.playerId ||
		pc.activePlayerId !== playerId ||
		paymentMode
	) {
		return;
	}

	return (
		<group>
			<mesh
				visible
				userData={{ hello: 'world' }}
				position={pos}
				rotation={[0, 0, 0]}
				onClick={(e) => {
					e.stopPropagation();
					buttonAction();
				}}
			>
				<boxGeometry args={[buttonWidth, 0.25, buttonHeight]} />
				<meshBasicMaterial
					attach="material"
					map={buttonTexture}
					side={DoubleSide}
				/>
			</mesh>
		</group>
	);
};

export default ButtonSquare3D;
